import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../assets/style-helpers.scss';
import { styles as flexBoxHelpersStyles } from '../../../assets/flexbox-helpers.scss';
import { styles } from '../../licenseBasicMonthlySubscriptionSubForm/view/template.scss';

export const templateLicenseBasicMonthlySubscriptionSubForm = document.createElement('template');

templateLicenseBasicMonthlySubscriptionSubForm.innerHTML = `
  <style>${styleHelpersStyles}</style>
  <style>${flexBoxHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div id='wrapper'>
    <gz-title fontSize='11' fontWeight='600' class='title' id='product-details-title'></gz-title>

    <gz-text id='basic-monthly-product-details-text' fontSize="12" class="mt-2 mb-1"></gz-text>

    <section class='subform-section'>
      <gz-text class='subform-section-label' fontSize="14" id='subscription-preferences-label'></gz-text>

      <div class='subform-section-fields'>
        <gz-form-field-toggleable class='toggle-field label-mw-250' id='reserve-seats-form-field'>
          <div class="d-flex align-items-center">
            <gz-input-number gz-form-input placeholder='' inputWidth='108'></gz-input-number>
            <gz-text class='ml-1 hidden' fontSize='13' id='available-seats-text'></gz-text>
          </div>
          <gz-input-error></gz-input-error>
        </gz-form-field-toggleable>

        <section class='text-form-field-section'>
          <gz-form-field-toggleable class='toggle-field label-mw-250' id='add-subscription-end-date-form-field'>
            <div class="d-flex">
              <gz-date-picker gz-form-input placeholder=''></gz-date-picker>
            </div>
            <gz-input-error></gz-input-error>
          </gz-form-field-toggleable>

          <gz-text fontSize="12" class="mb-1" id="add-subscription-end-date-text"></gz-text>
        </section>

        <section class='text-form-field-section'>
          <gz-form-field-toggleable class='toggle-field label-mw-250' id='set-auto-renewal-form-field' disabled>
            <div class="d-flex">
              <gz-input-number gz-form-input placeholder='' inputWidth='108'></gz-input-number>
            </div>
            <gz-input-error></gz-input-error>
          </gz-form-field-toggleable>

          <gz-text fontSize="12" class="mb-1" id="set-auto-renewal-text"></gz-text>
        </section>

         <section class='text-form-field-section'>
          <gz-form-field-toggleable class='toggle-field label-mw-250' id='minimum-usage-form-field'>
            <div class="d-flex">
              <gz-input-number gz-form-input placeholder='' inputWidth='108'></gz-input-number>
            </div>
            <gz-input-error></gz-input-error>
          </gz-form-field-toggleable>

          <gz-text fontSize="12" class="mb-1" id="minimum-usage-text"></gz-text>
        </section>

      </div>
    </section>

    <gz-license-monthly-addons-form class='hidden' id='own-use-addons-form'></gz-license-monthly-addons-form>
    <gz-license-monthly-addons-form class='hidden' id='reselling-addons-form'></gz-license-monthly-addons-form>
  </div>
`;
